import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd298ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "blue-bg mt-7 pt-10 mobile-height",
  style: {"height":"330px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blue-bg text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1-custom" }, "Need Guidance?"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle-2 mt-2" }, "We'd love to help you.")
], -1))
const _hoisted_3 = { class: "d-flex text-center justify-center" }
const _hoisted_4 = {
  class: "color-white",
  href: "tel:1800-123-7476"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  class: "color-white",
  href: "https://api.whatsapp.com/send?phone=8248964053"
}, "Whatsapp", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_support_form = _resolveComponent("jt-support-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_row, { class: "mt-5 d-flex text-center justify-center cursor-pointer mx-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "d-flex text-center justify-center cursor-pointer" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "btn-border px-6",
                          "prepend-icon": "mdi-headset",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showSupport = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Support")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", _hoisted_4, [
                          _createVNode(_component_v_btn, {
                            class: "btn-border px-6",
                            "prepend-icon": "mdi-phone"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Call us")
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "btn-border px-6",
                          "prepend-icon": "mdi-whatsapp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_v_dialog, {
      persistent: "",
      modelValue: $setup.showSupport,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.showSupport) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_jt_support_form, {
          onClosePopup: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeBookNow()))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}